import type {FormEventHandler, ReactNode} from 'react'

interface DialogFormProps {
    onSubmit: FormEventHandler<HTMLFormElement>
    children: ReactNode
    'data-testid'?: string
}

export function DialogForm({onSubmit, children, 'data-testid': testId}: DialogFormProps) {
    return (
        <form className="space-y-4" onSubmit={onSubmit} data-testid={testId}>
            {children}
        </form>
    )
}
